import JsQuestionsList from "../../../../src/custom/radio/JsQuestionsList";
import ReactQuestionsList from "../../../../src/custom/radio/ReactQuestionsList";
import * as React from 'react';
export default {
  JsQuestionsList,
  ReactQuestionsList,
  React
};